import Dexie, { type Table } from 'dexie';
import {
  type BackupBlobRow,
  type BackupRow,
  type ChunkBlobRow,
  type ChunkRow,
  type RecordingRow,
} from './types';
import { attachWriteFence } from './writeFence';

export const DB_V2_NAME = 'HEIDI_AUDIO_LEDGER';

/**
 * Separate database from legacy `HEIDI_AUDIO`: no version bump for old
 * bundles, corruption recovery can drop it without touching legacy data.
 * Metadata is split from blob bytes so scans never load audio.
 */
export class AudioDatabaseV2 extends Dexie {
  recordings!: Table<RecordingRow, [string, string]>;
  chunks!: Table<ChunkRow, [string, string, number]>;
  chunkBlobs!: Table<ChunkBlobRow, [string, string, number]>;
  backups!: Table<BackupRow, [string, string]>;
  backupBlobs!: Table<BackupBlobRow, [string, string]>;

  constructor(name: string = DB_V2_NAME) {
    super(name);

    this.version(1).stores({
      recordings: '[sessionId+recordingId], sessionId',
      chunks: '[sessionId+recordingId+index], [sessionId+recordingId], status',
      chunkBlobs: '[sessionId+recordingId+index]',
      backups: '[sessionId+recordingId], status',
      backupBlobs: '[sessionId+recordingId]',
    });
  }
}

export const dbV2 = new AudioDatabaseV2();
// Attach before open because Dexie builds its DBCore stack during open().
attachWriteFence(dbV2, 'v2');

/** Checks for prior ledger activation without opening or creating the database. */
export const ledgerDatabaseExists = (): Promise<boolean> => Dexie.exists(DB_V2_NAME);
